<div
  class="tw-inline-grid tw-place-items-stretch tw-place-content-center tw-grid-cols-1 @xl:tw-grid-cols-2 @4xl:tw-grid-cols-3 tw-gap-4 [&_a]:tw-max-w-none @5xl:[&_a]:tw-max-w-72"
>
  @for (report of reports(); track report) {
    <div>
      <app-report-card
        [title]="report.title | i18n"
        [description]="report.description | i18n"
        [route]="report.route"
        [variant]="report.variant"
        [icon]="report.icon"
      ></app-report-card>
    </div>
  }
</div>
